import styled from 'styled-components';
import { rem } from 'polished';
import { VehicleDetailsHeadingInformationStyled } from '../VehicleDetailsHeadingInformationStyled';
export const VehicleDetailsHeadingInformationStyledAP = styled(VehicleDetailsHeadingInformationStyled)`
    .delivery {
        background: ${({ theme }) => theme.colors.grey7};
        font-size: ${rem('12px')};
    }

    .information > .titleWithBenefits {
        .title {
            font-size: ${rem('18px')};
        }

        .specs .specs-title {
            font-size: ${rem('14px')};
        }

        .show-characteristics-button {
            position: relative;
            width: fit-content;
            .link {
                font-size: ${rem('12px')};
                color: ${({ theme }) => theme.colors.primary};
            }

            .icon-wrapper {
                margin-left: ${rem('10px')};

                svg {
                    width: fit-content;
                    height: ${rem('8px')};

                    path {
                        fill: ${({ theme }) => theme.colors.primary} !important;
                        stroke: ${({ theme }) => theme.colors.primary} !important;
                    }
                }
            }

            &:hover {
                .link {
                    border-bottom: none;
                }

                &:after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 1px;
                    background-color: ${({ theme }) => theme.colors.primary};
                }
            }
        }
    }
`;
